import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TrpcService } from 'src/app/services/trpc/trpc.service';
import { DailySummarySettings } from '../../../../../express-tRPC/src/api/lot-settings/types';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-daily-summary-configuration',
  templateUrl: './daily-summary-configuration.component.html',
  styleUrl: './daily-summary-configuration.component.scss'
})
export class DailySummaryConfigurationComponent {

  // Store the location ID for access within the template
  locationId = '';

  settingsForm = new FormGroup({
    daily_summary_report_type: new FormControl<string>('', [Validators.required]),
    daily_summary_calculate_revenue_method: new FormControl<string>('', [Validators.required]),
    daily_summary_dont_report_cc_fees: new FormControl<boolean>(true, [Validators.required]),
    daily_summary_dont_track_lost_tickets: new FormControl<boolean>(true, [Validators.required]),
    daily_summary_report_cc_fees_to_tickets_collected: new FormControl<boolean>(true, [Validators.required]),
    daily_summary_multi_shift_enabled: new FormControl<boolean>(true, [Validators.required]),
  });

  reportTypeOptions: any[] = [
    { code: 'surepark', name: 'SUREPARK'},
    { code: 'cashier', name: 'Cashier' },
    { code: 'wps', name: 'WPS' },
    { code: 'syspark', name: 'Syspark' }
  ];

  calculateRevenueMethods: any[] = [{
    key: 'Use Validated and Non-Validated Income',
    name: 'Use Validated and Non-Validated Income'
  }, {
    key: 'Use Revenue Summary',
    name: 'Use Revenue Summary'
  }];

  formSubmitted: boolean = false;
  loadingSettings: boolean = false;
  savingSettings: boolean = false;

  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService
  ) {
    this.getSettings();
  }

  async getSettings() {

    this.loadingSettings = true;

    let locationSettings: DailySummarySettings | void = await this.trpcService.trpc.settings.getDailySummarySettings.query().catch((error: any) => {
      this.loadingSettings = false;
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });

    if (locationSettings) {
      this.locationId = locationSettings.locationID;

      this.settingsForm.setValue({
        daily_summary_report_type: locationSettings.daily_summary_report_type || 'surepark',
        daily_summary_calculate_revenue_method: locationSettings.daily_summary_calculate_revenue_method || 'Use Validated and Non-Validated Income',
        daily_summary_dont_report_cc_fees: Boolean(locationSettings.daily_summary_dont_report_cc_fees || 0),
        daily_summary_dont_track_lost_tickets: Boolean(locationSettings.daily_summary_dont_track_lost_tickets || 0),
        daily_summary_report_cc_fees_to_tickets_collected: Boolean(locationSettings.daily_summary_report_cc_fees_to_tickets_collected || 0),
        daily_summary_multi_shift_enabled: Boolean(locationSettings.daily_summary_multi_shift_enabled || 0)
      });

    }

    this.loadingSettings = false;

  }

  async saveSettings(suppliedSettings: any = undefined) {

    this.messageService.clear();

    this.formSubmitted = true;
    if (this.settingsForm.invalid && !suppliedSettings) {
      if (this.settingsForm.errors?.['mutuallyExclusive']) {
        this.messageService.add({
          severity: 'error',
          detail: 'Please select either Default Group Stations OR Default Group Lot, not both.'
        });
      } else if (this.settingsForm.errors?.['timezoneExclusive']) {
        this.messageService.add({
          severity: 'error',
          detail: 'Please select either Default Timezone Group OR Default Timezone, not both.'
        });
      }
      return;
    }

    this.formSubmitted = false;

    this.savingSettings = true;
    const formValues: any = this.settingsForm.value;

    await this.trpcService.trpc
      .settings
      .set
      .mutate({
        settings: formValues
      }).then(() => {
        this.messageService.add({
          severity: "success",
          detail: "Daily Import Summary Settings saved successfully.",
        });

        this.savingSettings = false;
        this.getSettings();
      }).catch((error: any) => {
        this.savingSettings = false;
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });
  }

  backToPortal(): void {
    location.href = environment.SITE_URL_LOCAL;
  }
}
